import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import UnitDocumentType from 'src/app/shared/enums/unit-bank-account/UnitDocumentType.enum';
import { UnitDocumentConfirmDialogContext } from './UnitDocumentConfirmDialogContext.model';

@Component({
  selector: 'terra-unit-document-confirm-dialog',
  templateUrl: './unit-document-confirm-dialog.component.html',
  styleUrls: ['./unit-document-confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitDocumentConfirmDialogComponent implements OnInit {

  // consts:
  UnitDocumentType = UnitDocumentType;

  documentDescription = this.data.documentName;
  documentType = this.data.documentType;

  fileNameFront = this.data.metaFileLink.title;
  fileUrlFront = this.domSanitizer.bypassSecurityTrustResourceUrl(this.data.metaFileLink.url);
  fileTypeFront = this.data.metaFileLink.mediaType.toLowerCase().indexOf('pdf') >= 0 ? 'pdf' : 'image';

  fileNameBack = this.data.backSideMetaFileLink?.title;
  fileUrlBack = this.domSanitizer.bypassSecurityTrustResourceUrl(this.data.backSideMetaFileLink?.url);
  fileTypeBack = this.data.backSideMetaFileLink?.mediaType.toLowerCase().indexOf('pdf') >= 0 ? 'pdf' : 'image';

  hasBackSide = !!this.data.backSideMetaFileLink;

  constructor(
    private domSanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<UnitDocumentConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UnitDocumentConfirmDialogContext
  ) {}

  ngOnInit(): void {}

  confirm() {
    this.dialogRef.close(true);
  }

}
